import { motion } from "framer-motion";
import { Reveal, Eyebrow, SectionTitle } from "../Reveal";

const CELLS = [
  { label: "Vis", qty: 240, level: 85 },
  { label: "Chevilles", qty: 27, level: 25 },
  { label: "Wago", qty: 38, level: 45 },
  { label: "Écrous", qty: 96, level: 60 },
  { label: "Rondelles", qty: 150, level: 70 },
  { label: "Colliers", qty: 61, level: 55 },
  { label: "Petits raccords", qty: 12, level: 15 },
  { label: "Consommables", qty: 45, level: 50 },
];

export default function Compartments() {
  return (
    <section id="compartiments" className="py-16 sm:py-24 bg-[#141619]/40 border-y border-[#2E333D]/50" data-testid="compartments-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Organisation</Eyebrow>
          <SectionTitle>8 compartiments. Un suivi indépendant.</SectionTitle>
          <p className="mt-6 text-gray-400 max-w-2xl leading-relaxed">
            Chaque compartiment suit son propre contenu : rangement de petites pièces,
            accès rapide, possibilité de nettoyage — une organisation professionnelle,
            du véhicule au chantier.
          </p>
        </Reveal>
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4">
          {CELLS.map((c, i) => {
            const low = c.qty < 30;
            return (
              <Reveal key={c.label} delay={i * 0.05}>
                <div className="border border-[#2E333D] bg-[#0C0D0E] rounded-xl p-5 hover:border-[#FFC700]/40 transition-colors" data-testid={`compartment-cell-${i}`}>
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-[10px] uppercase tracking-widest text-gray-600">Comp. 0{i + 1}</span>
                    <span className="font-mono text-[9px] uppercase tracking-widest text-gray-600">Quantité estimée</span>
                  </div>
                  <p className="mt-3 font-display text-xl font-bold uppercase text-[#F9FAFB]">{c.label}</p>
                  <motion.p
                    initial={{ opacity: 0, y: 6 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.2 + i * 0.06 }}
                    className={`mt-1 font-display text-2xl font-extrabold leading-none ${low ? "text-red-400" : "text-[#FFC700]"}`}
                    data-testid={`compartment-qty-${i}`}
                  >
                    ≈ {c.qty} <span className="text-sm font-semibold">pièces</span>
                  </motion.p>
                  <div className="mt-3 h-1 rounded-full bg-[#2E333D] overflow-hidden">
                    <motion.div
                      initial={{ width: 0 }}
                      whileInView={{ width: `${c.level}%` }}
                      viewport={{ once: true }}
                      transition={{ duration: 1, delay: 0.2 + i * 0.06, ease: "easeOut" }}
                      className={`h-full rounded-full ${low ? "bg-red-500" : "bg-[#FFC700]/70"}`}
                    />
                  </div>
                  <p className="mt-2 text-[11px] text-gray-600">Exemple visuel — estimation non garantie</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
